<script>
import moment from "moment/src/moment";
import Loader from "../../widgets/loader.vue";
import { saveAs } from "file-saver";
import { service } from "../../../helpers/service";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import useVuelidate from "@vuelidate/core";
// import { required } from "@vuelidate/validators";
import { PaginationWithRangeMix } from '../../../mixes/PaginationMix';

const headers = [
  {
    index: "uuid",
    label: "UUID",
    filter: false,
    selected: false,
  },
  {
    index: "estado_validacion_cfdi",
    label: "Estado",
    filter: false,
    selected: false,
  },
  {
    index: "folio",
    label: "Folio",
    filter: false,
    selected: false,
  },
  {
    index: "serie",
    label: "Serie",
    filter: false,
    selected: false,
  },
  {
    index: "tipo",
    label: "Tipo",
    filter: false,
    selected: false,
  },
  {
    index: "total",
    label: "Total",
    filter: false,
    selected: false,
  },
  {
    index: "metodo_pago",
    label: "Método de pago",
    filter: false,
    selected: false,
  },
  {
    index: "fecha_emision",
    label: "Fecha de emisión",
    filter: false,
    selected: false,
  },
  {
    index: "fecha_timbrado",
    label: "Fecha de timbrado",
    filter: false,
    selected: false,
  },
  {
    index: "fecha_recepcion",
    label: "Fecha de recepción",
    filter: false,
    selected: false,
  },
  {
    index: "operaciones",
    label: "Operaciones",
    filter: false,
    selected: false,
  },
];

/**
 * Listado de CFDIs recibidos Component
 */
export default {
    name: "Listado de CFDIs recibidos",
    mixins: [PaginationWithRangeMix],
	setup(){
		return {v$:useVuelidate()};
	},
    components: {
        Layout,
        PageHeader,
        Loader
    },
    data() {      
      var startDateInicio = new Date();
        startDateInicio.setMonth(startDateInicio.getMonth());
        var startDateFin = new Date();
        return {
            fechaInicial: undefined,
            fechaFinal: undefined,
            startDateInicio: startDateInicio,
            startDateFin: startDateFin,
            busqueda:{
                tipo_busqueda_fecha: "created_at",
                reception_status:"*",
                efecto_comprobante: "*",
                created_at_after: "",
                created_at_before: "",
                uuid: "",
                folio: "",
                serie: "",
                metodo_pago: "*",
            },
            updating: false,
            listaRespuesta: [],
            headers,
        };
    },
	validations: {
        busqueda:{
            // created_at_after:{
            //     required
            // },
            // created_at_before:{
            //     required
            // },
            uuid:{
                customUuid(value){
                    if(!value){
                        return true;
                    }else{
                        if(value.length < 36){
                            return /^[0-9a-fA-F]+(?:-[0-9a-fA-F]+)*$/.test(value);
                        }else{
                        // como son 36 caracteres debe evaluarse la estructura completa
                        return /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(value);
                    }
                }
                }
            },
        }
	},
    mounted() {
        this.getListadoCfdisRecibidos();
        // this.getCtalogsDataFormaDePago();
        // this.setFechaHoy();
    },
    methods: {
        limpiarCamposBusqueda(){
            this.busqueda.tipo_busqueda_fecha = "created_at";
            this.busqueda.reception_status = "*";
            this.busqueda.efecto_comprobante = "*";
            this.busqueda.uuid = "";
            this.busqueda.folio = "";
            this.busqueda.serie = "";
            this.busqueda.metodo_pago = "*";
            this.getListadoCfdisRecibidos();
        },
        updateFechaFinal(date) {
            this.fechaFinal = new Date(date).toISOString().substr(0, 10); // Formato YYYY-MM-DD
            this.startDateFin = new Date(date);
        },
        updateFechaInicial(date) {
            this.fechaInicial = new Date(date).toISOString().substr(0, 10);
            this.startDateInicio = new Date(date);
        },
        // setFechaHoy(){
        //     let now = new Date();

        //     let year = now.getFullYear();
        //     let month = String(now.getMonth() + 1).padStart(2, "0");
        //     let day = String(now.getDate()).padStart(2, "0");

        //     let dayMenosUnDia = String(now.getDate()-1).padStart(2, "0");

        //     this.busqueda.created_at_after = `${year}-${month}-${dayMenosUnDia}`;
        //     this.busqueda.created_at_before = `${year}-${month}-${day}`;
        // },
        async descargarArchivo(uuid, xml_b64){
            let buffer = this.base64ToArrayBuffer(xml_b64);
            this.downloadFileXML(buffer, uuid);
        },
        setExtensionIfNameDoesntHaveit(name,extension){
            if(name.endsWith(extension)){
                return name;
            }
            return name+=extension;
        },
        downloadFileXML(data, name) {
            var blob = new Blob([data], { type: 'text/xml;charset=utf-8' });
            name= this.setExtensionIfNameDoesntHaveit(name,'.xml');
            saveAs(blob, name);
        },
        base64ToArrayBuffer(base64) {
            let binary_string = window.atob(base64);
            let len = binary_string.length;
            let bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        },
        async getListadoCfdisRecibidos(){
        this.v$.$touch();

        if(this.v$.$invalid){
          await this.$confirm.error("Completa los campos requeridos");
          return;
        }

        const tablePagination = this.pagination;
        /*
        created_at_after=2025-01-24
        created_at_before=2025-01-25
        reception_status=*
        uuid_eq=e09a75a4-b94a-4f95-a841-593f2df1068c
        page=1
        page_size=5
        rfc_emisor_eq=IXS7607092R5
        uuid_cont=e09a75a4
        select=xml_b64
        */
        let payload = {
            reception_status:           "*",
            select:                     "xml_b64",
            folio:                      this.busqueda.folio,
            serie:                      this.busqueda.serie,
            efecto_comprobante:         this.busqueda.efecto_comprobante,
            metodo_pago:                this.busqueda.metodo_pago,
            page:                       tablePagination.page,
            page_size:                  tablePagination.pageSize
          }

        if(this.busqueda.uuid != ''){
            if(this.busqueda.uuid.length < 36){
                payload.uuid_cont = this.busqueda.uuid;
            }else{
                payload.uuid_eq = this.busqueda.uuid;
            }
        }

        let inicialMoment = moment(this.fechaInicial).startOf('day');
        let finalMoment = moment(this.fechaFinal).endOf('day');
        this.busqueda.created_at_after = inicialMoment.format("YYYY-MM-DD");
        this.busqueda.created_at_before   = finalMoment.format("YYYY-MM-DD");

        if(this.busqueda.tipo_busqueda_fecha == 'created_at'){
            payload.created_at_after = this.busqueda.created_at_after;
            payload.created_at_before = this.busqueda.created_at_before;

            delete payload.fecha_emision_after;
            delete payload.fecha_emision_before;

            delete payload.fecha_certificacion_after;
            delete payload.fecha_certificacion_before;
        }
        if(this.busqueda.tipo_busqueda_fecha == 'fecha_emision'){
            payload.fecha_emision_after = this.busqueda.created_at_after;
            payload.fecha_emision_before = this.busqueda.created_at_before;

            delete payload.created_at_after;
            delete payload.created_at_before;

            delete payload.fecha_certificacion_after;
            delete payload.fecha_certificacion_before;
        }
        if(this.busqueda.tipo_busqueda_fecha == 'fecha_certificacion'){
            payload.fecha_certificacion_after = this.busqueda.created_at_after;
            payload.fecha_certificacion_before = this.busqueda.created_at_before;

            delete payload.fecha_emision_after;
            delete payload.fecha_emision_before;

            delete payload.created_at_after;
            delete payload.created_at_before;
        }

        try {
          this.updating=true;

          const response = await service.getListadoCfdisRecibidos(payload);

          if(response.success){
            if(response.data.total > 0){
              this.listaRespuesta = response.data;
              tablePagination.actualShow = response.data.items.length;
              tablePagination.collectionSize = response.data.total;
            }else{
              this.listaRespuesta = [];
            }
          }else{
            console.log('Algo falló');
            console.log(response.data);
            await this.$confirm.error("Algo falló, intenta de nuevo por favor");
          }
        } catch (error) {
          console.log('error');
          console.log(error);
        } finally {
          this.updating=false;
        }
      }
    },
    computed: {
    },
    watch: {
        "busqueda.folio":function(value){
            let resultado = /^\d+$/.test(value);
            if(!resultado){
                this.busqueda.folio = '';
            }
        },
        "busqueda.uuid":function(newVal){
            let lastChar = newVal.charAt(newVal.length - 1);
            if(lastChar == lastChar.toUpperCase()){
                this.busqueda.uuid = newVal.toLowerCase();
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader title="Listado de CFDIs recibidos" />
        <Loader :loading="updating">
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="uuid">UUID:</label>
                            <input 
                                type="text" 
                                class="form-control" 
                                maxlength="36" 
                                v-model.trim="busqueda.uuid"
                                :class="{'is-invalid': v$.busqueda.uuid.$error}"
                            >
                            <div v-if="v$.busqueda.uuid.$error" class="invalid-feedback">
                                <span v-if="v$.busqueda.uuid.customUuid.$invalid">
                                    Formato de UUID invalido
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="folio">Folio:</label>
                            <input type="text" class="form-control" maxlength="40" v-model.trim="busqueda.folio">
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="serie">Serie:</label>
                            <input type="text" class="form-control" maxlength="25" v-model.trim="busqueda.serie">
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="tipo">Tipo de documento:</label>
                            <select class="form-select" v-model="busqueda.efecto_comprobante">
                                <option value="*">Todos</option>
                                <option value="I">Ingreso</option>
                                <option value="E">Egreso</option>
                                <option value="P">Pago</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="metodoPago">Método de pago:</label>
                            <select class="form-select" v-model="busqueda.metodo_pago">
                                <option value="*">Todos</option>
                                <option value="PPD">PPD - Pago en parcialidades o diferido</option>
                                <option value="PUE">PUE - Pago en una sola exhibición</option>
                            </select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="busquedaPorFecha">Búsqueda por fecha:</label>
                            <select class="form-select" v-model="busqueda.tipo_busqueda_fecha">
                                <option value="created_at">Fecha de recepción</option>
                                <option value="fecha_emision">Fecha de emisión</option>
                                <option value="fecha_certificacion">Fecha de timbrado</option>
                            </select>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="fechaInicio">Fecha inicial:</label>
                            <datepicker-select-d
                                :startDate="startDateInicio"
                                @dateChanged="updateFechaInicial"
                            >
                            </datepicker-select-d>
                            <!-- <input id="fecha-inicio" type="date" class="form-control" v-model="busqueda.created_at_after"/> -->
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3">
                            <label for="fechaFin">Fecha final:</label>
                            <datepicker-select-d
                                :startDate="startDateFin"
                                :min-date="fechaInicial"
                                @dateChanged="updateFechaFinal"
                            >
                            </datepicker-select-d>
                            <!-- <input id="fecha-fin" type="date" class="form-control" v-model="busqueda.created_at_before"/> -->
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end">
                            <button class="btn btn-primary me-2" title="Buscar" @click="getListadoCfdisRecibidos">
                                <i class="fa fa-search"></i>
                            </button>
                            <button class="btn btn-primary" title="Limpiar campos de busqueda" @click="limpiarCamposBusqueda">
                                <i class="fa fa-eraser"></i>
                            </button>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <table-pagination 
                            :headers="headers" 
                            :pagination="pagination"
                            @on-pagination="pagination = $event"
                            :callback-search="getListadoCfdisRecibidos"
                        >
                            <template v-slot:tbody>
                                <tr class="table-hover" v-for="item in listaRespuesta.items" :key="item.numero">
                                    <td>
                                        {{ item.uuid }}
                                    </td>
                                    <td>
                                        <div v-if="item.reception_status == 'ACCEPTED'">
                                            <span class="badge bg-success">
                                                ACEPTADO
                                            </span>
                                        </div>
                                        <div v-if="item.reception_status == 'REJECTED'">
                                            <span class="badge bg-danger">
                                                RECHAZADO
                                            </span>
                                        </div>
                                        <div v-if="item.reception_status == 'IN_PROCESS'">
                                            <span class="badge bg-warning">
                                            EN PROCESO
                                            </span>
                                        </div>
                                          <div v-if="item.reception_status == 'WAIT'">
                                            <span class="badge bg-warning">
                                            EN ESPERA
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        {{ item.folio }}
                                    </td>
                                    <td>
                                        {{ item.serie }}
                                    </td>
                                    <td>
                                        {{ item.efecto_comprobante }}
                                    </td>
                                    <td>
                                        {{ item.total_cfdi }}
                                    </td>
                                    <td>
                                        {{ item.metodo_pago }}
                                    </td>
                                    <td>
                                        {{ item.fecha_emision }}
                                    </td>
                                    <td>
                                        {{ item.fecha_certificacion }}
                                    </td>
                                    <td>
                                        {{ item.created_at }}
                                    </td>
                                    <td>
                                        <button
                                            id="btn_view_product"
                                            title="Descargar"
                                            class="btn btn-sm btn-info"
                                            @click="descargarArchivo(item.uuid, item.xml_b64)"
                                        >
                                            <i class="fa fa-file-download" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </table-pagination>
                    </div>
                </div>
            </div>
        </div>
        </Loader>
    </Layout>
</template>